import styled from 'styled-components';
import { BREAKPOINTS, COLOR, FONT_SIZE } from "../themes";
import { Modal } from './Modal';
import { useEffect, useState } from 'react';
import { Input } from './Input';
import { hasErrors, validate } from '../helpers/validation';
import { useParams, useSearchParams } from 'react-router-dom';
import {EmailSubscribe} from "./EmailSubscribe";

export const Container = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-top: 4rem;
  background-color: ${COLOR.grayDark};
  color: ${COLOR.white};

  @media (min-width: ${BREAKPOINTS.md}) {
    padding-top: 6rem;
  }
`;

export const PageWrapper = ({ children }) => {
  const [searchParams] = useSearchParams();
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);

  useEffect(() => {
    const subscribe = searchParams.get('subscribe');
    setIsEmailModalOpen(subscribe === '1');
    
  }, [searchParams]);

  return (
    <Container>
      {isEmailModalOpen && (
        <EmailSubscribe setIsEmailModalOpen={setIsEmailModalOpen}/>
      )}
      {children}
    </Container>
  );
};